import { useNavigate } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface RetakeAssessmentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Resets the in-progress assessment so the user starts a fresh pass.
 *
 * We intentionally do NOT delete the user's previous results from the
 * server (`assessment_results` table). Those persist until the user
 * completes a new pass which then overwrites them.
 */
export const resetAssessmentProgress = () => {
  localStorage.removeItem("careerGPS_answers");
  localStorage.removeItem("careerGPS_completed");
  // Allow the celebratory confetti to fire again on the next results view.
  localStorage.removeItem("careerGPS_confettiFired");
  window.dispatchEvent(new Event("assessmentStateChanged"));
};

const RetakeAssessmentDialog = ({ open, onOpenChange }: RetakeAssessmentDialogProps) => {
  const navigate = useNavigate();

  const handleConfirm = () => {
    resetAssessmentProgress();
    onOpenChange(false);
    navigate("/assessment");
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Retake assessment?</AlertDialogTitle>
          <AlertDialogDescription>
            This will reset your answers and recalculate your results. Your access stays unlocked - you won't be charged again.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            className="bg-tk-primary text-white hover:bg-tk-primary/90"
          >
            Retake assessment →
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default RetakeAssessmentDialog;
